import {
    Component
  } from '@angular/core';
  import { FieldType } from '@ngx-formly/core';
  @Component({
    selector: 'custom-repeater',
    template: `
    <mat-list>
    <mat-list-item *ngFor="let option of to.options; let i = index">
      <h3 mat-line>{{ option.label }}</h3>
    </mat-list-item>
  </mat-list>
    `,
    standalone: false
})
  // eslint-disable-next-line @angular-eslint/component-class-suffix
  export class CheckboxRepeat extends FieldType {
  
    constructor() {
      super();
    }
    
    onChange(option: any, checked: boolean) {
      this.formControl.patchValue(this.to.options);
      this.formControl.markAsTouched();
    }
  }
  